import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { useOauth2Client, useOauth2Principal } from '../oauth2.hooks';
import { goToDashboard } from '../../actions/changePassword';
import { Loader } from '@design-system/atoms/loader';
import { Typography } from '@design-system/atoms/typography';
import useSearchParams from '../../hooks/useSearchParams';

const ErrorSubtitle = styled(Typography)`
  padding-top: 4px;
  color: ${({ theme }) => theme.colors.technical.gray[60]};
`;

const Oauth2LoginError = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Typography variant="h2">{formatMessage({ id: 'login.error.prefix' })}</Typography>
      <Typography variant="h2">{formatMessage({ id: 'login.error.message.general' })}</Typography>
      <ErrorSubtitle>{formatMessage({ id: 'login.error.retryHint' })}</ErrorSubtitle>

      <img
        style={{ width: '330px', height: '349px', paddingTop: '16px' }}
        src="/laptop-illustration.png"
        alt="Laptop illustration"
      />
    </>
  );
}

const Oauth2LoginRedirect = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useOauth2Principal();
  const { loginRedirect } = useOauth2Client();

  useEffect(() => {
    if (isAuthenticated === true) {
      dispatch(goToDashboard());
    } else if (isAuthenticated === false) {
      loginRedirect();
    }
  }, [isAuthenticated, loginRedirect, dispatch]);

  return <Loader />;
};

const Oauth2Login = () => {
  const searchParams = useSearchParams();

  if (searchParams.get('error')) {
    return <Oauth2LoginError />
  }
  return <Oauth2LoginRedirect />;
};

export default Oauth2Login;
